import service from '@/store/services/workshop/nota_jasa_bkl-service';

const state = {
  list: {},
  nota_jasa_bkl: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, nota_jasa_bkl) => {
    state.nota_jasa_bkl = nota_jasa_bkl;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((nota_jasa_bkl) => { commit('SET_RESOURCE', nota_jasa_bkl); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((nota_jasa_bkl) => { commit('SET_RESOURCE', nota_jasa_bkl); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((nota_jasa_bkl) => { commit('SET_RESOURCE', nota_jasa_bkl); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((nota_jasa_bkl) => { commit('SET_RESOURCE', nota_jasa_bkl); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  nota_jasa_bkl: state => state.nota_jasa_bkl,
  page: state => state.meta.page,
};


 
const nota_jasa_bkl = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default nota_jasa_bkl;
